import { render, staticRenderFns } from "./verifyUser.vue?vue&type=template&id=2be95594&"
import script from "./verifyUser.vue?vue&type=script&lang=js&"
export * from "./verifyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports